import React, { useContext, useMemo } from 'react'
import { ScenarioStatesProviderContext } from '../providers/StatesProvider'

const useLoader = () => {
    const context = useContext(ScenarioStatesProviderContext)
    if (context === undefined) {
        throw new Error('useLoader must be used within a Scenario States Provider')
    }

    const { loading, setLoading, formData } = context
    const { assets } = useMemo(() => formData, [formData])
    const presim = useMemo(() => assets.presim, [assets.presim])
    const presimRunning = useMemo(() => {
        const data = presim?.data;
        if (!data) return false;
        return Object.keys(data).some(key => data[key]?.status === "running");
    }, [presim?.data]);
    return { loading, setLoading, presimRunning }
}

export default useLoader